import Slider from "react-slick";
import Trailer from "./Trailer";
function TrailerSlider({ data, headerImage, clName }) {
  let settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    // fade: true,
    // cssEase: "linear",
  };

  return (
    <div className="container mt-4">
      <div className="container-fluid">
        <div className={`text-center mb-2 ${clName}`}>
          <img
            className="img-fluid faw-orig"
            src={headerImage}
            alt="Fawesome Oirginals"
          />
        </div>

        <div>
          <Slider {...settings}>
            {data.map((item, key) => {
              return <Trailer data={item} key={key}></Trailer>;
            })}
          </Slider>
        </div>
      </div>
    </div>
  );
}
export default TrailerSlider;
